import styled from '@emotion/styled'

export const TabListStyled = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  margin: 0;
  padding: 0;
  border: none;
  background: var(--builder-tabs-background);
  flex-shrink: 0;

  .tabs {
    position: relative;
    overflow: hidden;
    width: 100%;

    .tab-holder {
      display: flex;
    }

    .tab {
      font-size: 11px;
      font-weight: bold;
      padding: 9px 12px;
      float: left;
      position: relative;
      border-left: 1px solid transparent;
      border-right: 1px solid transparent;
      color: var(--builder-tabs-inactive-color);
      min-width: 60px;
      text-align: center;

      &.active {
        background: var(--builder-panel-background);
        border-radius: 2px 2px 0 0;
        color: var(--builder-text-color);
        ::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(rgb(255 255 255 / 4%), transparent);
          z-index: -1;
        }
      }

      &:first-of-type {
        border-left-width: 0;
      }

      > div {
        overflow: hidden;
      }
    }
  }

  .tab-holder {
    overflow: visible;
    transition: transform 0.2s;
    white-space: nowrap;

    .tab {
      position: relative;
      transition: transform 0.2s, z-index 0.4s;
      white-space: nowrap;
      max-width: 240px;
      z-index: 1;
    }
  }
`;
